export enum OrganisationRole {
  owner = "Owner",
  employee = "Employee",
  editor = "Editor",
}
